<template>
<div id="joke">
    <headernav type="joke"></headernav>
    <div class="content">
        <!-- <elmenu type="sellment"></elmenu> -->
        <!-- <router-view></router-view> -->
        <el-row type="flex" justify="center" class='search-area'>
            <el-col :md="22" :sm="24" :lg="14" :xs="24" id="joke-selections">
                <el-input
                    placeholder="选择场景:如动物、家庭。。。"
                    v-model="scene"
                    clearable>
                    <el-button slot="append" @click="handleScenarioChange">搜索</el-button>
                </el-input>
                <el-select v-model="rate" clearable placeholder="选择分级" @change="handleRateChange">
                    <el-option
                    v-for="(key,value) in rating"
                    :key="value"
                    :label="key"
                    :value="value">
                    </el-option>
                </el-select>
                <el-select v-model="interlude" clearable placeholder="选择过场音效" @change="handleInterludeChange">
                    <el-option
                    v-for="(item,index) in interludeItems"
                    :key="index"
                    :label="item.name"
                    :value="item.url">
                    </el-option>
                </el-select>
            </el-col>
        </el-row>

        <el-row type="flex" justify="center">
            <el-col :md="22" :sm="24" :lg="14" :xs="24" id="joke-list">
                <div class="joke-items">
                    <div class="joke-item" :id="'floor'+index" v-for="(item,index) in jokedata" :key="index">
                        <div class="joke-item-header">
                            <p class="scenario">{{item.scenario}}</p>
                            <p class="rating">{{item.rating}}、{{jokeRate[item.rating]}}</p>
                            
                        </div>
                        <p class="title">{{item.title}}</p>
                        <div class="joke-item-content">
                            <div class="stuff-info">
                                <span>作者：{{item.author}}</span>
                                <span>审核：{{item.auditor}}</span>
                            </div>
                            <div class="text">
                                <p>{{item.content}}</p>
                            </div>
                            <div class="tags">
                                {{item.tags}}
                            </div>
                        </div>
                        <div class="sound" v-bind:class="{active: currentIndex===index}">
                            <div @click='playMusic(index)' class="joke-play-button"><img v-if='isPlayed && currentClick===index?true:false' src='../../static/img/ibroadcast/play.png'><img v-else src='../../static/img/ibroadcast/pause.png'></div>
                            <audio  ref='audio' @ended='jokeEnd(index)' :src="item.url">
                                抱歉！您的浏览器暂不支持播放此音频，请更换或升级浏览器
                            </audio>
                        </div>
                    </div>
                </div>

                <div class="joke-pagination">
                    <el-pagination
                        @current-change="handlePageChange"
                        :current-page.sync="page"
                        layout="total, prev, pager, next, jumper"
                        :total="joketotal">
                        </el-pagination>
                </div>
            </el-col>
        </el-row>
        <div class='bg-audio' v-show='bgAudio'>
            <audio  ref='bgAudio' @ended='bgEnd()' :src="interludeUrl" >
                抱歉！您的浏览器暂不支持播放此音频，请更换或升级浏览器
            </audio>
        </div>
    </div>
</div>
</template>

<script type="text/javascript">
import {mapGetters, mapActions} from 'vuex';
import * as types from './../../store/mutation.js';
import { getNowTime, routeMap } from '../../utils/com.js'
import headernav from '../inavmenu/headernav.vue'
// import elmenu from '../inavmenu/elmenu.vue'
import '../../static/style/joke/index.scss'
import { cloneObj } from '../../utils/com.js'
import { Loading } from 'element-ui';
import { jokeScenario, jokeRating } from '../../config/config'

export default {
    data() {
        return {
        isPlayed:true,
        bgAudio:false,
        scenario:null,
        rating:null,
        scene:null,
        rate:null,
        interlude:null,
        page:1,
        clientid:1,
        limit:10,
        author:null,
        newPageList:[],
        musicList:[],
        currentClick:null,
        }
    },
    components: {
        headernav,
        // elmenu
    },
    computed:{
        ...mapGetters({
            jokedata:'jokeData',
            joketotal:'jokeTotalItem',
            interludeItems:'interlude',
            getAccesstoken: 'getAccesstoken',
            getAppid: 'getAppid',
            interludeUrl: 'interludeUrl',
            currentIndex: 'currentIndex',
            autoplay: 'autoplay'
        }), 
        jokeRate:()=>jokeRating,
    },
    created(){
        this.scenario=jokeScenario;
        this.rating=jokeRating;
        let curpage = this.$route.query.page || 1;
        this.page = parseInt(curpage);
        this.reqJokeListData();  
    },
    watch: {
      '$route' (to, from){
        console.debug("watch>route start to:%o, from:%o", to, from);
        console.debug("watch>route page:%o", this.$route.query.page);
        let curpage = this.$route.query.page || 1;
        this.page = parseInt(curpage);
        this.scene = this.$route.query.scenario;
        this.rate = this.$route.query.rating;
        this.reqJokeListData();
      }
    },
    mounted(){
        // this.autoplayjoke();
        this.reqInterludeList();
    },
    updated(){
        this.autoplayjoke();
        this.musicList = this.$refs.audio;
    },
    methods:{
        ...mapActions({
          // 映射 this.getJokeList 为 store.getters.getJokeList
          getJokeList: 'getJokeList',
          updateLoadingStatus: 'updateLoadingStatus',
          getInterludeList: 'getInterludeList',
          setInterludeUrl: 'setInterludeUrl',
          setCurrentIndex: 'setCurrentIndex',
          setAutoPlay: 'setAutoPlay',
          outLogin: 'outLogin',
        }),
        playMusic(index){
            if(index!==this.currentIndex){
                this.isPlayed = true;
                this.setAutoPlay(false);
                this.currentClick = index;
                this.setCurrentIndex(index);
                for(let v of this.musicList){
                if(v.currentTime != 0){
                    v.pause();
                    v.currentTime = 0;
                    }
                }
                this.isPlayed=false; 
                this.musicList[index].play();
                
            }else{
                // console.log(2);
                this.isPlayed=!this.isPlayed;
                if(this.isPlayed){
                    this.musicList[index].pause();
                    // this.isPlayed = false;
                }else{   
                    this.musicList[index].play();
                    // this.isPlayed = true;
                }   
            }   
        },
        jokeEnd(_index){
            var _that_ = this;
            this.setAutoPlay(true);
            this.isPlayed=true;
            var music = this.$refs.audio;
            let index = this.currentIndex;
            let pageItems = Math.ceil(this.joketotal/10)+1;
            if(this.interludeUrl){
                this.$nextTick(()=>
                    _that_.$refs.bgAudio.play()
                )
            }else{
                // console.log(music);
                if(music){
                    index++;
                    this.setCurrentIndex(index);
                    // console.log(this.currentIndex);
                    if(index < music.length){
                        music[index].play();
                        this.goToAnchor('floor'+index);
                    }else{
                        this.page++;
                        // console.log(this.page);
                        // console.log(pageItems);
                        if(this.page < pageItems){
                            this.handlePageChange(this.page);
                            // console.log(this.page);
                        }else{
                            console.log('全部播放完毕');
                            this.setAutoPlay(false);
                            return
                        } 
                    }
                }  
            }
            
        },
        bgEnd(){
            var music = this.$refs.audio;
            let index = this.currentIndex;
            let pageItems = Math.ceil(this.joketotal/10)+1;
            index++;
            this.setCurrentIndex(index);
            if(index < music.length){
                music[index].play();
                this.goToAnchor('floor'+index);
            }else{
                this.page++;
                // console.log(this.page);
                // console.log(pageItems);
                if(this.page < pageItems){
                    this.handlePageChange(this.page);
                    // console.log(this.page);
                }else{
                    console.log('全部播放完毕');
                     this.setAutoPlay(false);
                    return
                } 
            } 
        },
        autoplayjoke(){
            var items = this.$refs.audio;
            // console.log(items);
            var isAnyItemPlayed = '';
            if(items[0]){
                for(let v of items){
                if(v.currentTime != 0){
                    isAnyItemPlayed = true;
                }
                    // console.log(v.currentTime);
                }
                if(items && this.autoplay && !isAnyItemPlayed){
                    items[0].play();
                    this.setCurrentIndex(0);
                }
            }
            
        },
        goToAnchor(index){
            var anchor = document.getElementById(index);
            let total = anchor.offsetTop;
            document.body.scrollTop = total;
            document.documentElement.scrollTop = total;
            window.pageYOffset = total;
        },
        reqJokeListData:function(){
            var _that_ = this;
            var param = {
                appid: _that_.getAppid,
                accesstoken: _that_.getAccesstoken,
                scenario:_that_.scene,
                rating:_that_.rate,
                author:_that_.author,
                page:_that_.page,
                limit:_that_.limit,
            }
            // console.log(param);
            _that_.updateLoadingStatus(true);
            _that_.getJokeList(param).then(
            (resp) => {
              _that_.updateLoadingStatus(false);
              console.debug("reqNewsListData> getJokeList> resp:%o", resp);
              if(resp && resp.code !== 0){
                _that_.$message({
                      message: resp.msg,
                      type: 'error'
                  });
                  setTimeout(() => {
                    _that_.outLogin();
                    _that_.$router.push({ path: routeMap('/login'),query: { type: 'joke' }})
                  }, 3000);
              }
            }
          );

        },
        reqInterludeList(){
            var _that_ = this;
            let param = {
                appid: _that_.getAppid,
                accesstoken: _that_.getAccesstoken,
                clientid:_that_.clientid,
                scenario:_that_.scene
            }
            _that_.getInterludeList(param).then(
            (resp) => {
              console.debug("getInterludeList> resp:%o", resp);
              if(resp && resp.code !== 0){
                _that_.$message({
                      message: resp.msg,
                      type: 'error'
                  });
                  setTimeout(() => {
                    _that_.outLogin();
                    _that_.$router.push({ path: routeMap('/login'),query: { type: 'joke' }})
                  }, 3000);
              }
            }
          );
        },
        handleScenarioChange(){
            this.$router.push({ path: routeMap('/joke/list'), query: { page: this.page,scenario: this.scene,rating: this.rate} });
        },
        handleRateChange(){
            this.$router.push({ path: routeMap('/joke/list'), query: { page: this.page,scenario: this.scene,rating: this.rate} });
        },
        handleInterludeChange(val){
            // console.log(val);
            this.setInterludeUrl(val);
        },
        handlePageChange(val) {
          console.debug("handlePageChange> val:%o", val);
          if(this.page !== val){
            this.page = val;
          }
          this.$router.push({ path: routeMap('/joke/list'), query: { page: this.page,scenario: this.scene,rating: this.rate} });

        },
    }
}
</script>



// WEBPACK FOOTER //
// index.vue?d81627e4